export default "__VITE_PUBLIC_ASSET__b6963dfb__"